// extracted by mini-css-extract-plugin
export var fadeIn = "_70-0";